<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-6 col-sm-6 col-md-3 col-lg-3 col-xl-3">
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <!-- 사용여부 -->
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-select
            :comboItems="useFlagItems"
            type="search"
            itemText="codeName"
            itemValue="code"
            name="useFlag"
            label="사용여부"
            v-model="searchParam.useFlag"
          ></c-select>
        </div>
      </template>
    </c-search-box>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
        <c-table
          ref="placetable"
          title="장소 목록"
          :columns="grid.columns"
          :data="grid.data"
          :usePaging="false"
          @rowClick="rowClick"
        >
          <!-- 버튼 영역 -->
          <template slot="table-button">
            <q-btn-group outline >
              <c-btn label="검색" icon="search" @btnClicked="getList" />
            </q-btn-group>
          </template>
        </c-table>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-8 col-lg-8 col-xl-8">
        <c-tab
          type="tabcard"
          :tabItems.sync="tabItems"
          :inlineLabel="true"
          v-model="tab"
          align="left"
        >
          <template v-slot:default="tab">
            <component
              :is="tab.component"
              :resultItems="resultItems"
              :lines="lines"
              :pick="pick"
              @getList="getList"
              @rowClick="rowClick"
            />
          </template>
        </c-tab>
      </div>
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'patrol-place-item',
  data() {
    return {
      tab: 'patrolPlaceItemResult',
      tabItems: [
        { name: 'patrolPlaceItemResult', icon: 'groups', label: '점검항목', component: () => import(`${'./patrolPlaceItemResult.vue'}`) },
        { name: 'patrolPlaceLine', icon: 'list', label: '라인', component: () => import(`${'./patrolPlaceLine.vue'}`) },
      ],
      searchParam: {
        plantCd: '',
        useFlag: 'Y',
      },
      grid: {
        columns: [
          {
            name: 'placeName',
            field: 'placeName',
            label: '장소',
            align: 'left',
            sortable: true,
            style: 'width:200px',
          },
          {
            name: 'itemCnt',
            field: 'itemCnt',
            label: '점검항목 갯수',
            align: 'right',
            sortable: true,
            style: 'width:60px',
            type: 'cost',
          },
          {
            name: 'useFlag',
            field: 'useFlag',
            label: '사용여부',
            align: 'center',
            sortable: true,
            style: 'width:40px',
          },
        ],
        data: [],
      },
      editable: true,
      useFlagItems: [
        { code: 'Y', codeName: '사용' },
        { code: 'N', codeName: '미사용' },
      ],
      popupOptions: {
        isFull: false,
        width: '50%',
        target: null,
        title: '',
        visible: false,
        param: {},
        closeCallback: null,
      },
      pick: {
        plantCd: '',
        placeId: '',
      },
      resultItems: [],
      lines: [],
      isSave: false,
      listUrl: '',
      detailListUrl: '',
      insertUrl: '',
      deleteUrl: '',
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.sai.patrol.resultItem.place.url;
      this.detailListUrl = selectConfig.sai.patrol.resultItem.list.url;
      // code setting
      // list setting
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    rowClick(row) {
      if (!row) return;
      this.pick.plantCd = row.plantCd
      this.pick.placeId = row.placeId
      this.$http.url = this.detailListUrl;
      this.$http.type = 'GET';
      this.$http.param = {
        placeId: row.placeId,
        plantCd: row.plantCd
      }
      this.$http.request((_result) => {
        if (_result.data.resultItems) {
          this.$_.forEach(_result.data.resultItems, item => {
            item.placeId = this.$_.clone(this.pick.placeId)
          })
          this.resultItems = _result.data.resultItems;
        }
        if (_result.data.lines) {
          this.$_.forEach(_result.data.lines, item => {
            item.placeId = this.$_.clone(this.pick.placeId)
          })
          this.lines = _result.data.lines;
        }
      },);
    },
  }
};
</script>
